module.exports = __webpack_public_path__ + "ecosystem_trial-v.0c291aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem_trial-v.png
// module id = 2589
// module chunks = 0